import React from 'react';
import { TargetIcon, HeartIcon, ShieldIcon } from 'lucide-react';
export function AboutPage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-40">
      {/* Hero */}
      <section className="relative py-32 bg-gray-900 overflow-hidden" data-id="element-41">
        <div className="absolute inset-0" data-id="element-42">
          <img src="https://images.unsplash.com/photo-1611348524140-53c9a25263d6?w=1200&q=80" alt="Nairobi city skyline" className="w-full h-full object-cover opacity-40" data-id="element-43" />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent" data-id="element-44"></div>
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" data-id="element-45">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight" data-id="element-46">
            About Prompt Airtime
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-2xl mx-auto" data-id="element-47">
            Discover the journey and vision behind Kenya's trusted digital
            airtime platform.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-24" data-id="element-48">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-50">
            <div className="order-2 lg:order-1" data-id="element-51">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-52">
                Our Mission
              </h2>
              <div className="w-20 h-1 bg-emerald-500 mb-8 rounded-full" data-id="element-53"></div>
              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-54">
                Our mission is simple: make airtime accessible to every Kenyan.
                We partner with Safaricom, Airtel, and Telkom to deliver
                instant, affordable top-ups that keep you connected to what
                matters most.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-55">
                With a focus on convenience and affordability, we are committed
                to delivering top-notch service that meets the dynamic needs of
                our growing customer base across the nation.
              </p>
            </div>
            <div className="order-1 lg:order-2 relative" data-id="element-56">
              <div className="absolute inset-0 bg-emerald-100 rounded-3xl transform translate-x-4 translate-y-4 -z-10" data-id="element-57"></div>
              <img src="https://cdn.magicpatterns.com/uploads/j8V1nce2CwNeHdbwy8uRfT/pexels-elsimage-4570062V.jpg" alt="Woman talking on the phone" className="rounded-3xl shadow-xl w-full h-auto object-cover aspect-[4/3]" data-id="element-58" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-24 bg-gray-50 border-y border-gray-100" data-id="element-59">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
          <div className="bg-white p-10 md:p-16 rounded-3xl shadow-sm border border-gray-100 text-center relative overflow-hidden" data-id="element-61">
            <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-50 rounded-bl-full -z-0" data-id="element-62"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-emerald-50 rounded-tr-full -z-0" data-id="element-63"></div>

            <div className="relative z-10" data-id="element-64">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-65">
                Our Story
              </h2>
              <p className="text-xl text-gray-700 leading-relaxed font-medium" data-id="element-66">
                Founded in the heart of Nairobi's Westlands district, Prompt
                Airtime began with a bold idea — that buying airtime should be
                as easy as sending a text. From our office at Unga House, we've
                grown from a small startup to a platform trusted by over 100,000
                customers across Kenya.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24" data-id="element-67">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
          <div className="text-center mb-16" data-id="element-69">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-70">
              Our Core Values
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-71">
              The principles that guide everything we do.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-72">
            <div className="text-center p-8 rounded-2xl hover:bg-gray-50 transition-colors duration-300" data-id="element-73">
              <div className="mx-auto h-20 w-20 bg-emerald-50 rounded-2xl flex items-center justify-center mb-8 transform rotate-3 hover:rotate-6 transition-transform" data-id="element-74">
                <TargetIcon className="h-10 w-10 text-emerald-500" data-id="element-75" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-76">
                Convenience
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-77">
                We believe staying connected should be effortless. Our platform
                is designed to be intuitive, fast, and accessible 24/7 from any
                device.
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl hover:bg-gray-50 transition-colors duration-300" data-id="element-78">
              <div className="mx-auto h-20 w-20 bg-emerald-50 rounded-2xl flex items-center justify-center mb-8 transform -rotate-3 hover:-rotate-6 transition-transform" data-id="element-79">
                <HeartIcon className="h-10 w-10 text-emerald-500" data-id="element-80" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-81">
                Affordability
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-82">
                We offer competitive rates and regular discounts to ensure our
                customers get the absolute best value for their money on every
                transaction.
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl hover:bg-gray-50 transition-colors duration-300" data-id="element-83">
              <div className="mx-auto h-20 w-20 bg-emerald-50 rounded-2xl flex items-center justify-center mb-8 transform rotate-3 hover:rotate-6 transition-transform" data-id="element-84">
                <ShieldIcon className="h-10 w-10 text-emerald-500" data-id="element-85" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-86">
                Reliability
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-87">
                Trust is our foundation. We guarantee secure M-PESA transactions
                and instant airtime delivery for every single purchase made.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}